module.exports = __webpack_public_path__ + "bella-596e2fe93fef7bdbf6e653c21e7585c0.bundle.jpg";